/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS migration — Marketing/Funnel — RTK Query slice. Real GrowthOsDeal +
   growthos_revenue_daily throughout; Leads/budget/ad-platform data is pending
   (no contacts collection, no ad-platform spend sync) and rendered on the
   frontend, not this slice.
   ──────────────────────────────────────────────────────────────────────────── */
import { createApi } from '@reduxjs/toolkit/query/react'
import { apiConstants, get } from '../common/constants'

const MARKETING_FUNNEL = apiConstants.GROWTHOS_ADMIN_MARKETING_FUNNEL

const run = async (promise) => {
  try {
    const res = await promise
    return { data: res?.data }
  } catch (err) {
    const r = err?.response
    return {
      error: {
        status: r?.status,
        data: r?.data,
        message: r?.data?.message || err.message,
      },
    }
  }
}

export const growthosMarketingFunnelApiSlice = createApi({
  reducerPath: 'growthosMarketingFunnelApi',
  baseQuery: () => ({ data: undefined }),
  tagTypes: ['MarketingFunnel'],
  endpoints: (b) => ({
    getMarketingFunnel: b.query({
      queryFn: ({ period, from, to }) => run(get(MARKETING_FUNNEL, { period, from, to })),
      providesTags: ['MarketingFunnel'],
    }),
  }),
})

export const { useGetMarketingFunnelQuery } = growthosMarketingFunnelApiSlice
